import {Component, Inject, OnInit, Optional} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {IHolidays} from 'src/app/interfaces/settings.iterfaces';
import {DIALOG_DATA} from 'src/app/services/dialog.service';
import {DialogRef} from 'src/app/shared/ui-kits/dialog/dialog-ref';
import {Utils} from 'src/app/shared/utils/utils';
import {wordCountValidator} from 'src/app/validators/custom.validators';

@Component({
  selector: 'app-holidays-modal',
  templateUrl: './holidays-modal.component.html',
  styleUrls: ['./holidays-modal.component.scss'],
})
export class HolidaysModalComponent implements OnInit {
  public form!: UntypedFormGroup;
  public isEqualObject = Utils.isEqualObjects;
  public isFieldInvalid = Utils.isFieldInvalid;
  constructor(
    private fb: UntypedFormBuilder,
    private dialogRef: DialogRef,
    @Optional() @Inject(DIALOG_DATA) public data: IHolidays
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      date: new UntypedFormControl(this.data.date, [Validators.required]),
      comment: new UntypedFormControl(this.data.comment, [
        wordCountValidator(400),
      ]),
      name: new UntypedFormControl(this.data.name, [
        Validators.required,
        Validators.maxLength(40),
      ]),
      id: new UntypedFormControl(this.data.id),
    });
    if (sessionStorage.getItem('selected_date') && !this.data.id) {
      this.form.get('date')?.setValue(sessionStorage.getItem('selected_date'));
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  saveData() {
    if (this.form.invalid) {
      return Utils.validateAllFormFields(this.form);
    }
    if (this.isEqualObject(this.data, this.form.value)) {
      this.dialogRef.close();
    } else {
      this.dialogRef.close(this.form.value);
      sessionStorage.setItem('selected_date', this.form.get('date')?.value);
    }
  }

  deleteHoliday() {
    this.dialogRef.close('delete');
  }
}
